<template>
  <div class="product-card-container">
    <router-link :to="productDetailpageUrl">
      <div class="product-card-main-content pt-6 noto-sans-sc-font-family">
        <v-img :src="imageSrc" height="120px" contain></v-img>
        <div class="product-title text-center">{{ title }}</div>
        <!-- <div class="product-price d-flex justify-center align-center py-2">{{ displayPrice }}</div> -->
        <div class="product-rating text-center pb-5">
          <!-- <v-rating v-model="rating" color="#e2211c" small dense readonly></v-rating> -->
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    imageSrc: {
      type: String,
      required: true
    },
    // displayPrice: {
    //   type: String,
    //   required: true
    // },
    rating: {
      type: Number,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    productDetailpageUrl() {
      // return "/product/dp/" + this.id;
      // return "/product/" + this.id;
      // return "/p/" + this.id;
      return "/" + this.id;
    }
  }
};
</script>

<style scoped>
.product-title {
  font-size: 13px;
  color: #333333;
  margin-top: 30px;
  padding-left: 2px !important;
  padding-right: 2px !important;
}

.product-price {
  color: #999999;
  font-size: 13px;
}
</style>>
